import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { PayrollLoadingState } from "./employee/payroll/PayrollLoadingState";
import { PayrollHeader } from "./employee/payroll/PayrollHeader";
import { PayrollSummaryCards } from "./employee/payroll/PayrollSummaryCards";
import { PayrollDetailsTable } from "./employee/payroll/PayrollDetailsTable";
import { PayrollActions } from "./employee/payroll/PayrollActions";
import { usePayrollData } from "./employee/payroll/usePayrollData";
import { usePayrollProcessing } from "./employee/payroll/usePayrollProcessing";

export const PayrollProcessing: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const employeeIds = searchParams.get('employees')?.split(',') || [];
  const startDate = searchParams.get('startDate') || '';
  const endDate = searchParams.get('endDate') || '';

  const { payrollData, loading } = usePayrollData({
    employeeIds,
    startDate,
    endDate
  });

  const { processing, processPayroll } = usePayrollProcessing();

  const handleProcessPayroll = () => {
    processPayroll(payrollData, startDate, endDate);
  };

  const handleCancel = () => {
    navigate('/employee-time-calendar');
  };

  if (loading) {
    return <PayrollLoadingState />;
  }

  return (
    <div className="container mx-auto p-6">
      <PayrollHeader 
        period={{ startDate, endDate }}
        onBack={handleCancel}
      />

      <PayrollSummaryCards payrollData={payrollData} />

      <PayrollDetailsTable payrollData={payrollData}>
        <PayrollActions
          onCancel={handleCancel}
          onProcess={handleProcessPayroll}
          processing={processing}
          disabled={processing || payrollData.length === 0}
        />
      </PayrollDetailsTable>
    </div>
  );
};